/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Plain plus icon (no circle) used by the Quick Schedule "Add new" header action.
 *
 * @file PlusIcon.jsx
 * @author Gladson Samuel S
 * @since 3.1.0
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

const PlusIcon = (props) => (
  <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M7.99972 1.55142C8.43694 1.55142 8.79171 1.90619 8.79171 2.34341V7.20865H13.6569C14.094 7.2087 14.4488 7.56259 14.4489 7.99966C14.4489 8.43686 14.0941 8.79161 13.6569 8.79166H8.79171V13.6569C8.79166 14.0941 8.43691 14.4489 7.99972 14.4489C7.56266 14.4487 7.20876 14.094 7.2087 13.6569V8.79166H2.34347C1.90624 8.79166 1.55148 8.43689 1.55148 7.99966C1.55163 7.56256 1.90634 7.20865 2.34347 7.20865H7.2087V2.34341C7.2087 1.90628 7.56262 1.55157 7.99972 1.55142Z" fill="currentColor" />
  </SvgIcon>
);

export default PlusIcon;
